import React from 'react'
import parse from 'html-react-parser'

const NewsGame = ({ round, news, gameTitle, gameTip }) => {
    const { title, description, source, image, url } = news

    return (
        <div>
            <h3 className='pb-2'>Ronda {round} de 10</h3>
            <h1 className='pb-2 leading-tight'>{gameTitle}</h1>
            <h5 className='pb-2 font-light'>{gameTip}</h5>
            <hr className='mb-6' />
            <h4 className='headline-style'>{parse(title)}</h4>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8'>
                <div className='order-last md:order-first'>
                    <p className='mb-4'>{description}</p>
                    <p className='src-legend p-0'><a href={url} target='_blank' rel="noopener noreferrer">fonte: {source.name}</a></p>
                </div>
                {image &&
                    <div className='order-first md:order-last'>
                        <img
                            className='mb-2 rounded object-cover w-full'
                            alt='Imagem da notícia'
                            src={image === true ? require('../../assets/img/others/question_mark.jpg') : image}
                        />
                    </div>
                }
            </div>
            <hr className='mt-6' />
        </div>
    )
}

export default NewsGame
